// AUTOMATIC UPDATES (Karan 21/10/2026). A tab that has been told a newer build
// exists (app/version, the "new version" bar) reloads ITSELF once the update has
// waited long enough — 30 minutes, or 2 for a deploy marked critical — but only
// at a SAFE moment, so nobody loses what they are doing:
//   - the person has been idle for 2 minutes, or the tab is in the background;
//   - no dialog or panel is open, no text field has focus, nothing is uploading
//     or saving (window.__trackBusy > 0);
//   - the phone's offline queue survives a reload already (mobile/queue.js).
// Reloading keeps the address, so they come back to the same screen.
const IDLE_MS = 2 * 60 * 1000;
let seenAt = 0;
let graceMs = 30 * 60 * 1000;
let lastActivity = Date.now();
let timer = null;

['pointerdown', 'keydown', 'wheel', 'touchstart'].forEach((ev) => addEventListener(ev, () => { lastActivity = Date.now(); }, { passive: true, capture: true }));

function safeNow() {
  if (window.__trackBusy > 0) return false;
  if (document.querySelector('[role="dialog"], [role="alertdialog"]:not(#mx-pause)')) return false;
  const a = document.activeElement;
  if (a && (a.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName))) return false;
  return document.hidden || Date.now() - lastActivity >= IDLE_MS;
}

function tick() {
  if (!seenAt || Date.now() - seenAt < graceMs) return;
  if (safeNow()) location.reload();
}

/** Called when app/version says a newer build is live. */
export function newVersionSeen({ critical = false } = {}) {
  if (!seenAt) seenAt = Date.now();
  graceMs = critical ? 2 * 60 * 1000 : 30 * 60 * 1000;
  if (!timer) {
    timer = setInterval(tick, 30 * 1000);
    if (timer && typeof timer.unref === 'function') timer.unref();   // tests (Node); a no-op in browsers
    document.addEventListener('visibilitychange', tick);
  }
}

export const _autoUpdate = { safeNow, tick, state: () => ({ seenAt, graceMs, lastActivity }) };
